import { render, staticRenderFns } from "./personal-folder.vue?vue&type=template&id=10f56468&scoped=true&"
import script from "./personal-folder.vue?vue&type=script&lang=ts&"
export * from "./personal-folder.vue?vue&type=script&lang=ts&"
import style0 from "./personal-folder.vue?vue&type=style&index=0&id=10f56468&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f56468",
  null
  
)

export default component.exports